export default __webpack_public_path__ + "static/media/microservice.672503c4.jpeg";